import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages = [
  'https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20desk%20setup%20with%20laptop%20notebook%20and%20warm%20lighting%2C%20soft%20coral%20accents%2C%20editorial%20productivity%20style%2C%20cozy%20organized%20workspace%20atmosphere%2C%20natural%20textures%2C%20harmonious%20composition&width=800&height=500&seq=article-prod-tools&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Online%20learning%20workspace%20with%20open%20books%20tablet%20and%20coffee%2C%20warm%20lighting%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20minimalist%20study%20environment%2C%20editorial%20photography%2C%20clean%20desk%20with%20organized%20supplies%2C%20harmonious%20composition&width=800&height=500&seq=article-learning&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20browser%20window%20displayed%20on%20laptop%20screen%20with%20colorful%20extension%20icons%2C%20warm%20minimalist%20desk%20setup%2C%20soft%20coral%20accents%2C%20clean%20workspace%20atmosphere%2C%20editorial%20tech%20photography%2C%20natural%20light%2C%20harmonious%20composition&width=800&height=500&seq=article-extensions&orientation=landscape',
];

export default function ArticlePreview() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="w-full">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              推荐文章
            </h2>
            <p className="text-sm text-foreground-500">精选优质内容，发现更多精彩</p>
          </div>
          <Link
            to="/articles"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>查看全部</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer hover:scale-[1.01]"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[index] || articleImages[0]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-primary-100 text-primary-700">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}